/** Persisted Zustand store name for auth tokens/user. */
export const AUTH_STORE_PERSIST_KEY = 'auth-store';

export type AuthTokens = {
  accessToken?: string;
  refreshToken?: string;
};

export type AuthTokenPair = {
  accessToken: string;
  refreshToken: string;
};
